import { FormControlLabel, FormHelperText, Grid, Input, InputLabel, MenuItem, Select, Switch, TextField } from '@material-ui/core';
import Spin from 'components/Spin';
import { constants } from 'helpers';
import React, { Component } from 'react';
import { run } from 'validations/ruleRunner';

import Validations from './validations';
import { FormContent } from '../FormContent';
import styles from '../styles';

import type IProduct from 'interfaces/IProduct';

enum PARAMETERS {
  POST = 1,
  DEFAULT = 2,
  NONE = 3,
  GET = 99,
}

interface IProps {
  loading: boolean;
  fade?: boolean;
  product?: IProduct;
  handleImageChange?: Function;
  handleUploadEvents?: Function;
  modifieds?: any[];
  editing?: any;
  handleChange?: any;
  categoryList?: any;
  onChangeRequiredFields?: Function;
  classes?: any;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
}

class Advanced extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: run(props.product, Validations),
    };
  }

  errorFor = (field: any) => this.state.validationErrors[field] || '';
  isValid = (field: any) => !!this.state.validationErrors[field];

  componentDidUpdate(prevProps: IProps) {
    if (!this.props.loading && this.props.product !== prevProps.product) {
      let { product, onChangeRequiredFields } = this.props;
      let newState = { ...this.state };
      newState.validationErrors = run(product, Validations);
      this.setState(newState);
      if (onChangeRequiredFields) {
        onChangeRequiredFields('advancedRequiredFields', newState.validationErrors ? Object.keys(newState.validationErrors).length : 0);
      }
    }
  }

  render() {
    const { loading, classes, product, handleChange } = this.props;
    const isUrlAppBlinket = product?.url_thankyou_card?.includes('app.blinket') || product?.url_thankyou_boleto?.includes('app.blinket');

    if (loading) {
      return (
        <div className={classes.loadingPages}>
          <Spin />
        </div>
      );
    }

    return (
      <FormContent title='Avançado' loading={loading}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              className={classes.input}
              label='Url obrigado para cartão e PIX'
              id='url_thankyou_card'
              helperText={this.isValid('url_thankyou_card') ? this.errorFor('url_thankyou_card') : 'Ex: https://obrigadocartao.com.br'}
              error={this.isValid('url_thankyou_card')}
              fullWidth
              value={product.url_thankyou_card}
              onChange={(e: any) => handleChange('url_thankyou_card', e.target.value)}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              className={classes.input}
              label='Url obrigado para boleto'
              id='url_thankyou_boleto'
              helperText={this.isValid('url_thankyou_boleto') ? this.errorFor('url_thankyou_boleto') : 'Ex: https://obrigadoboleto.com.br'}
              error={this.isValid('url_thankyou_boleto')}
              fullWidth
              value={product.url_thankyou_boleto}
              onChange={(e: any) => handleChange('url_thankyou_boleto', e.target.value)}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel>Parâmetro</InputLabel>
            <Select
              id='format'
              fullWidth
              value={product.thankyou_type}
              input={<Input disableUnderline fullWidth />}
              onChange={(value: any) => handleChange('thankyou_type', value.target.value)}
            >
              <MenuItem value={PARAMETERS.NONE}>Nenhum</MenuItem>
              <MenuItem value={PARAMETERS.DEFAULT}>Padrão</MenuItem>
              {!isUrlAppBlinket && <MenuItem value={PARAMETERS.POST}>Post</MenuItem>}
              <MenuItem value={PARAMETERS.GET}>Get</MenuItem>
            </Select>
          </Grid>

          <Grid item xs={12}>
            <TextField
              className={classes.input}
              label='Url para o produto inativo'
              helperText={this.isValid('alternative_url') ? this.errorFor('alternative_url') : 'Ex: http://site.com'}
              id='alternative_url'
              error={this.isValid('alternative_url')}
              fullWidth
              value={product.alternative_url}
              onChange={(e: any) => handleChange('alternative_url', e.target.value)}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              label='Email de acesso da Eduzz'
              control={
                <Switch color='primary' checked={product.email_welcome} onChange={(e: any) => handleChange('email_welcome', e.target.checked)} />
              }
            />
            <FormHelperText>Envia e-mail de boas vindas de novo usuário com login e senha da Eduzz</FormHelperText>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              label='Endereço no checkout'
              control={
                <Switch
                  color='primary'
                  disabled={product.ask_address_thanks}
                  checked={product.ask_address_checkout}
                  onChange={(e: any) => handleChange('ask_address_checkout', e.target.checked)}
                />
              }
            />
            <FormHelperText>Deseja que seja pedido o endereço do cliente na página de checkout</FormHelperText>
          </Grid>
          {product.type !== constants.PHYSICAL && (
            <Grid item xs={12}>
              <FormControlLabel
                label='Endereço pós compra'
                control={
                  <Switch
                    color='primary'
                    disabled={product.ask_address_checkout}
                    checked={product.ask_address_thanks}
                    onChange={(e: any) => handleChange('ask_address_thanks', e.target.checked)}
                  />
                }
              />
              <FormHelperText>Deseja que seja pedido o endereço do cliente após confirmação da compra</FormHelperText>
            </Grid>
          )}

          <Grid item xs={12}>
            <FormControlLabel
              label='CPF/CNPJ do pagador'
              control={
                <Switch
                  color='primary'
                  checked={product.document_on_checkout}
                  onChange={(e: any) => handleChange('document_on_checkout', e.target.checked)}
                />
              }
            />
            <FormHelperText>Será solicitado o CPF/CNPJ do titular do cartão no checkout</FormHelperText>
          </Grid>
          {(product.type === constants.PHYSICAL || product.type === constants.TICKET) && (
            <Grid item xs={12}>
              <FormControlLabel
                label='Ocultar quantidade'
                control={
                  <Switch color='primary' checked={product.hide_quantity} onChange={(e: any) => handleChange('hide_quantity', e.target.checked)} />
                }
              />
              <FormHelperText>Oculta o campo de quantidade do produto no checkout deixando o valor padrão como 1 unidade</FormHelperText>
            </Grid>
          )}
        </Grid>
      </FormContent>
    );
  }
}

export default styles(Advanced);
